import { useContext, useEffect, useMemo, useState } from 'react'
import { UIContext } from 'Context/UI'
import { TableContext } from 'Context/Table'

import CustomToolbar from './Components/CustomToolbar'
import DoubleLineImage from 'Presentation/Components/Table/Cells/DoubleLineImage'
import { MOCK_DATA } from 'Data/mockMarketplaceProduct'
import formatNumberCommas from 'Utils/formatNumberCommas'
import formatNumberCommasNoDecimal from 'Utils/formatNumberCommasNoDecimal'

const ViewModel = () => {
	const { setCustomContentToolbar, setShowContentToolbar } = useContext(UIContext)
	const { updatePagination, updateLoading, updateSorting, updateError } = useContext(TableContext)
	const data = useMemo(() => MOCK_DATA, [])
	const [currentDataType, setCurrentDataType] = useState<
		'today' | 'thisweek' | 'thismonth' | 'bought'
	>('today')

	const setupTable = () => {
		updatePagination(true)
		updateLoading(false)
		updateError(false)

		setTimeout(() => {
			updateSorting('ranking', true)
		}, 500)
	}

	const TABLE_CONFIGS: any[] = [
		{
			Header: 'อันดับ',
			accessor: 'ranking',
			width: 100,
			minWidth: 100,
			Cell: ({ value }: any) => (
				<div className="text-kumopack-grey-600 fw-bold">{formatNumberCommasNoDecimal(value)}</div>
			),
		},
		{
			Header: 'สินค้า',
			accessor: 'customer',
			width: 600,
			minWidth: 600,
			Cell: ({ row }: any) => (
				<DoubleLineImage
					img={row.original?.product?.featurePicturePath}
					// img={
					// 	row.original?.buyerPictureProfilePath
					// 		? generateImageUrl(row.original?.buyerPictureProfilePath)
					// 		: null
					// }
					label={row.original?.product?.name}
					description={`SKU: ${row.original?.product?.sku}`}
				/>
			),
		},
		{
			Header: 'ยอดสั่งซื้อทั้งหมด',
			accessor: 'saleAmount',
			width: 120,
			minWidth: 120,
			Cell: ({ value }: any) => <span className="fw-bold">฿{formatNumberCommas(value)}</span>,
		},
		{
			Header: 'จำนวนออร์เดอร์',
			accessor: 'orderAmount',
			width: 120,
			minWidth: 120,
			Cell: ({ value }: any) => (
				<span className="fw-bold">{formatNumberCommasNoDecimal(value)}</span>
			),
		},
	]

	useEffect(() => {
		setupTable()
		setShowContentToolbar(true)
		setCustomContentToolbar(<CustomToolbar />)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		data,
		TABLE_CONFIGS,
		currentDataType,
		setCurrentDataType,
	}
}

export default ViewModel
